import { TooltipIconPropsModel } from './tooltip-icon-props.model';
import { Icon } from '../UI';

const TooltipIcon = (props: TooltipIconPropsModel) => {
  return (
    <div
      className={`
        flex
        justify-center
        items-center
        cursor-pointer
        ${
          props.tooltipIconColor
            ? 'text-' + props.tooltipIconColor
            : 'text-black'
        }
        ${props.tooltipIconClassname || ''}
      `}
      onClick={() => {
        if (props.onClick) props.onClick();
      }}
      onMouseEnter={() => {
        if (props.onMouseEnter) props.onMouseEnter();
      }}
      onMouseLeave={() => {
        if (props.onMouseLeave) props.onMouseLeave();
      }}
      ref={props.popperRef}
    >
      <Icon svgName="info" className="h-4 w-4" />
    </div>
  );
};

export default TooltipIcon;
